export default __webpack_public_path__ + "static/media/create-trustline-step-2.ffd68ec4.png";